<script setup lang="ts">
import { $t } from '@/composables/translations/useTranslate';

interface Props {
  showEditButton?: boolean;
  wrapperClass?: string;
  roundedTop?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  showEditButton: false,
  wrapperClass: '',
  roundedTop: true,
});

const emit = defineEmits<{
  edit: [];
}>();

function handleEdit() {
  emit('edit');
}
</script>

<template>
  <div :class="['flex flex-col', wrapperClass]">
    <div :class="['flex flex-col p-5 bg-white', props.roundedTop ? 'rounded-[10px]' : '']">
      <slot></slot>

      <button
        v-if="props.showEditButton"
        class="mt-7.5 btn-tertiary print:hidden"
        @click="handleEdit"
      >
        {{ $t('ibe.checkout.edit', 'Edit') }} <i class="w-5 h-5 bg-black icon icon-pen"></i>
      </button>
    </div>
  </div>
</template>
